/**
 * IMPORTS
 */
import { requestResetPasswordRepository } from "@/repositories/solicitar-recuperacao-senha-usuario";

/**
 * Função que solicita a recuperação de senha.
 */
const handleRequestResetPassword = async (email: string) => {
  try {
    const data = await requestResetPasswordRepository.requestResetPassword(email);
    return data;
  } catch (error: any) {
    // erro do backend padronizado
    const message =
      error?.response?.data?.errors?.message ||
      error?.response?.data?.message ||
      "Erro ao solicitar recuperação de senha!";

    throw new Error(message);
  }
};

/**
 * EXPORT
 */
export { handleRequestResetPassword };
